import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FC, useState } from 'react';

import { MarkdownEditor } from '../../../../shared/MarkdownEditor';
import {
    PlanContainer,
    PlanExpandToggle,
    StyledPaper,
    Title
} from './styled';

// Matches the threshold used by the dashboards' `ExpandablePlan` so the
// collapse/expand toggle only shows for plans worth collapsing.
const PREVIEW_CHAR_LIMIT = 600;

interface ImplementationPlanProps {
    plan: string;
}

const ImplementationPlan: FC<ImplementationPlanProps> = ({ plan }) => {
    const [ expanded, setExpanded ] = useState(false);

    if (!plan || !plan.trim()) {
        return null;
    }

    const isLongPlan = plan.length > PREVIEW_CHAR_LIMIT;
    const collapsed = isLongPlan && !expanded;

    return (
        <StyledPaper elevation={0}>
            <Title variant="h6">Implementation plan</Title>
            <PlanContainer collapsed={collapsed} data-color-mode="dark">
                <MarkdownEditor value={plan} readOnly />
            </PlanContainer>
            {isLongPlan && (
                <PlanExpandToggle
                    onClick={() => setExpanded((p) => !p)}
                    role="button"
                    aria-expanded={expanded}
                >
                    {expanded ? (
                        <>
                            Collapse <ExpandLessIcon fontSize="small" />
                        </>
                    ) : (
                        <>
                            Expand <ExpandMoreIcon fontSize="small" />
                        </>
                    )}
                </PlanExpandToggle>
            )}
        </StyledPaper>
    );
};

export default ImplementationPlan;
